'use strict';

/** @AppDialogsStore */
const AppDialogsStore = function ($http, $timeout, APP_DISPATCHER_ID, AppDialogsActions, Flux, IdentityService) {

  //Store init
  const AppDialogsStore = Flux.Store.create({
    name: 'AppDialogsStore',
    events: {
      Changed: true,
      SubscriptionExpired: true,
      OpenDialog: true,
      CloseDialog: true
    }
  });

  //Null initial state
  AppDialogsStore.$state = {
    plan_id: '',
    view: '',
    checkoutPage: '',
    siteToDelete: null
  };

  /**
   * Constructor function that binds to the interaction Flux.Action Signal from the component
   */
  AppDialogsStore.init = function init () {

    const dispatcher = Flux.Dispatcher.get(APP_DISPATCHER_ID);
    dispatcher.register(AppDialogsActions.GetSelectPlanPage, this._handleGetSelectPlanPage.bind(this));
    dispatcher.register(AppDialogsActions.GetCheckoutPage, this._handleGetCheckoutPage.bind(this));
    dispatcher.register(AppDialogsActions.GetSuccessfulSignup, this._handleGetSuccessfulSignup.bind(this));
    dispatcher.register(AppDialogsActions.NotSupportedInPlan, this._handleNotSupportedInPlan.bind(this));
    dispatcher.register(AppDialogsActions.SavingNotSupportedInPlan, this._handleSavingNotSupportedInPlan.bind(this));
    dispatcher.register(AppDialogsActions.DisabledForAdmins, this._handleDisabledForAdmins.bind(this));
    dispatcher.register(AppDialogsActions.InsufficientSubscriptionPrivileges, this._handleInsufficientSubscriptionPrivileges.bind(this));
    dispatcher.register(AppDialogsActions.UnableToFetchSubscription, this._handleUnableToFetchSubscription.bind(this));
    dispatcher.register(AppDialogsActions.MustBePayingCustomer, this._handlePromptMustActivateSubscription.bind(this));
    dispatcher.register(AppDialogsActions.PromptDeleteSite, this._handlePromptDeleteSite.bind(this));
    dispatcher.register(AppDialogsActions.PromptMapboxglWelcome, this._handlePromptMapboxglWelcome.bind(this));
  }.bind(this);

  // Handlers //////////////////////////////////////////////////////////////////

  this._handleInsufficientSubscriptionPrivileges = () => {

    AppDialogsStore.$set('view', 'insufficientSubscriptionPrivileges');
    AppDialogsStore.emit(AppDialogsStore.Events.OpenDialog);
  };

  this._handleGetSelectPlanPage = () => {

    AppDialogsStore.$set('view', 'selectPlans');
    AppDialogsStore.emit(AppDialogsStore.Events.OpenDialog);
  };

  this._handleGetCheckoutPage = (payload) => {

    AppDialogsStore.$set('plan_id', payload.plan_id);
    let url = IdentityService.getPaymentsApiUri() + 'organizations/' + IdentityService.getCurrentOrganization().id + '/checkout/' + payload.plan_id;
    if (payload.coupon_code) {
      url += '?coupon=' + payload.coupon_code;
    }
    const httpConfig = { url, method: 'GET' };
    return $http(httpConfig)
    .then((res) => {

      const response = res.data;
      if (response.data && response.data.hosted_page) {
        AppDialogsStore.$set('checkoutPage', response.data.hosted_page.url);
      }
      AppDialogsStore.$set('view', 'checkoutSubscription');
      AppDialogsStore.emit(AppDialogsStore.Events.OpenDialog);
      return response;
    })
    .catch((err) => {

      AppDialogsStore.emit(AppDialogsStore.Events.CloseDialog);
      $timeout(() => {

        AppDialogsStore.$set('view', 'unableToFetchSubscription');
        AppDialogsStore.emit(AppDialogsStore.Events.OpenDialog);
      }, 100);

      return err;
    });
  };

  this._handleGetSuccessfulSignup = () => {

    AppDialogsStore.$set('view', 'successfulSignup');
    AppDialogsStore.emit(AppDialogsStore.Events.OpenDialog);
  };


  this._handleNotSupportedInPlan = () => {

    AppDialogsStore.$set('view', 'notSupportedPlanFeature');
    AppDialogsStore.emit(AppDialogsStore.Events.OpenDialog);
  };

  this._handleSavingNotSupportedInPlan = () => {

    AppDialogsStore.$set('view', 'savingNotSupportedPlanFeature');
    AppDialogsStore.emit(AppDialogsStore.Events.OpenDialog);
  };

  this._handleDisabledForAdmins = () => {

    AppDialogsStore.$set('view', 'disabledForAdmins');
    AppDialogsStore.emit(AppDialogsStore.Events.OpenDialog);
  };

  this._handleUnableToFetchSubscription = () => {

    AppDialogsStore.$set('view', 'unableToFetchSubscription');
    AppDialogsStore.emit(AppDialogsStore.Events.OpenDialog);
  };

  this._handlePromptMustActivateSubscription = () => {

    AppDialogsStore.$set('view', 'promptMustActivateSubscription');
    AppDialogsStore.emit(AppDialogsStore.Events.OpenDialog);
  };

  this._handlePromptMapboxglWelcome = () => {

    AppDialogsStore.$set('view', 'mapboxglWelcome');
    AppDialogsStore.emit(AppDialogsStore.Events.OpenDialog);
    IdentityService.set('viewedMapboxglDialog', true);
  };

  this._handlePromptDeleteSite = (payload) => {

    AppDialogsStore.$set('view', 'promptDeleteSite');
    AppDialogsStore.$set('siteToDelete', payload.site);
    AppDialogsStore.emit(AppDialogsStore.Events.OpenDialog);
  };

  return AppDialogsStore;
};

AppDialogsStore.$inject = ['$http', '$timeout', 'APP_DISPATCHER_ID', 'AppDialogsActions', 'sbFlux', 'IdentityService'];

module.exports = AppDialogsStore;



// WEBPACK FOOTER //
// ./src/app/dialogs/AppDialogsStore.js